









import {Component, Vue} from 'vue-property-decorator';

@Component
export default class Spinner extends Vue {
    top = 0;

    mounted() {
        this.calculateTop();
    }

    calculateTop() {
        const nav = (document.querySelector('nav') as HTMLElement);
        if (nav) {
            this.top = (document.querySelector('nav') as HTMLElement).clientHeight;
        }
        else {
            this.top = 0;
        }
    }
}
